import template from './hudson-insurance.html';
import {
  ITEM_DEFINITION_CODES,
  ITEM_STATUSES,
  STATES,
} from '../../../constants';
import { actions, selectors } from '../../../state';
import './hudson-insurance.global.css';
import { trackEngagement } from '@mover-app/engagement';

function captureError(message, extra) {
  window.Raven.captureMessage(`Error: ${message}`, {
    extra,
    level: 'error',
  });
}

const QUOTE_TYPES = {
  AUTO: 'Auto',
  HOME: 'Home',
  ALL: 'All',
};

const LOGOS = [
  { name: 'American Commerce', id: 'AmericanCommerceLogo.png' },
  { name: 'MetLife', id: 'MetLifeLogo.png' },
  { name: 'Progressive', id: 'ProgressiveLogo.png' },
  { name: 'Travelers', id: 'TravelersLogo.png' },
  { name: 'National Grange Mutual', id: 'NationalGrangeMutualLogo.png' },
  { name: 'The Hartford', id: 'TheHartfordLogo.png' },
];

class HudsonInsuranceController {
  constructor($element, updStore) {
    'ngInject';
    Object.assign(this, {
      $element,
      updStore,
      dashboardSref: STATES.DASHBOARD,
      logos: LOGOS,
      quoteTypes: {
        auto: {
          value: QUOTE_TYPES.AUTO,
          selected: false,
        },
        home: {
          value: QUOTE_TYPES.HOME,
          selected: false,
        },
      },
    });
  }

  $onInit() {
    this.quote = getQuoteFromUserAndMove(this.updStore.getState());

    this.disconnect = this.updStore.connect(mapStateToThis)(this);
    trackEngagement({
      code: ITEM_DEFINITION_CODES.HUDSON_INSURANCE,
      name: 'Hudson Insurance',
    });
  }

  $postLink() {
    this.modal = this.$element.find('upd-dialog')[0];
  }

  $onDestroy() {
    this.disconnect();
  }

  closeModal() {
    this.modal.close();
  }

  submit(quote) {
    const { dispatch } = this.updStore;

    const completeItem = () =>
      dispatch(
        actions.item
          .singleton(this.itemId)
          .update({ status: ITEM_STATUSES.COMPLETED })
      );

    const showModal = () => Promise.resolve(this.modal.showModal());

    const error = () => {
      dispatch(
        actions.message.error(
          'Sorry. There was an error submitting your quote.'
        )
      );
    };

    dispatch(actions.velocifyProxy.create(quote))
      .then(completeItem)
      .then(showModal)
      .catch(error);
  }

  onQuoteTypeChange(type) {
    const { quoteTypes } = this;

    this.quote.quote_type = allQuoteTypesSelected(quoteTypes)
      ? QUOTE_TYPES.ALL
      : getSelectedQuoteType(quoteTypes);
  }
}

export const HudsonInsuranceComponent = {
  template,
  controller: HudsonInsuranceController,
};

function mapStateToThis(state) {
  const { current, pending } = selectors;

  return {
    submitting: pending.match(actions.velocifyProxy.isCreate, state),
    itemId: current.hasHudsonInsuranceMoveItem(state)
      ? current.hudsonInsuranceMoveItem(state).id(state)
      : null,
  };
}

function getQuoteFromUserAndMove(state) {
  const { current } = selectors;
  const user = current.user(state);
  const move = current.move(state);

  return {
    first_name: user.firstName(state),
    last_name: user.lastName(state),
    email: user.email(state),
    zip: move.toAddress(state).zip,
    quote_type: null,
  };
}

function getSelectedQuoteType(types) {
  const type = Object.keys(types).find(type => types[type].selected);
  return type ? types[type].value : null;
}

function allQuoteTypesSelected(types) {
  return Object.keys(types).every(type => types[type].selected);
}
